import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=256ef35a&lang=scss"

const __exports__ = script;

export default __exports__